import { LABELS } from '@app/config';
import createAxiosInstance from '../../../shared/axios/axiosClientFactory';

const CONFIG = {
  axiosOptions: {
    baseURL: '/',
    timeout: 30 * 1000,
    headers: {
      Accept: 'application/json',
      'X-Requested-With': 'XMLHttpRequest',
      'App-Platform': LABELS.APP_HUMAN_NAME,
      'App-Version': LABELS.APP_HUMAN_VERSION,
    },
  },
};

const agent = createAxiosInstance(CONFIG);

export default agent;
